export const RenderQuantum = 128 | 0;
